import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.gsdcuser.ticketing.item');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { ElementRef, ViewChild } from '@angular/core';
import ClassicEditor from "src/libs/portal/season/ckeditor/ckeditor";
import moment from "moment";
import showdown from 'showdown';
import { Router } from '@angular/router';

@Component({
    selector: 'wiz-portal-gsdcuser-ticketing-item',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.gsdcuser.ticketing.item/view.scss */
/* src/app/portal.gsdcuser.ticketing.item/view.scss: no such file or directory */`],
})
export class PortalGsdcuserTicketingItemComponent implements OnInit {
    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    @Input() ticket_id: any;

    @ViewChild('editor')
    public editorElement: ElementRef;
    public comments: any = [];
    public tags: any = [];
    public comment_text: any = '';
    public commentFiles: any = [];

    public item: any = {};
    public editor: any;

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(true, "/login");
        await this.load();
        await this.buildEditor();
        await this.service.loading.hide();
    }

    public async load() {
        const { code, data } = await wiz.call("get", { id: this.ticket_id });
        if (code != 200) return window.location = "/dashboard";
        this.item = data.item;
        this.comments = data.comments;
        this.tags = JSON.parse(data.item.tag.replace(/'/g, '"'));
        if (this.item.extra != null) this.item.extra = JSON.parse(this.item.extra.replace(/'/g, '"'));
        this.item.start_date = moment(this.item.start_date).format("YYYY-MM-DD");
        this.item.due_date = moment(this.item.due_date).format("YYYY-MM-DD");

        await this.service.render();
    }

    public showdown(text) {
        const markdown = typeof text === 'string' ? text : '';
        let converter = new showdown.Converter();
        return converter.makeHtml(markdown);
    }

    public async update() {
        if (this.item.title == "") return await this.service.alert.error("제목을 입력해주세요.")
        else if (this.tags.length == 0) return await this.service.alert.error("태그를 선택해주세요.")

        this.item.content = this.editor.data.get();
        this.item.tag = this.tags;
        let data: any = JSON.stringify(this.item);
        let { code } = await wiz.call("update", { data: data });
        if (code != 200) return await this.service.alert.error("Error!");
        await this.service.alert.success("저장되었습니다.")

        if (!this.item.id) {
            // await this.service.href(`/support/ticketing`);
            this.router.navigateByUrl('/support/ticketing');
        }
    }

    public async delete() {
        let res: any = await this.service.alert.error("정말로 삭제하시겠습니까?", "취소", "삭제");
        if (!res) return;
        const { code } = await wiz.call("delete", { id: this.item.id });
        if (code != 200) return await this.service.alert.error("Error!");
        this.router.navigateByUrl('/support/ticketing');
    }

    public async sendComment() {
        this.comment_text = this.editor.data.get();
        if (!this.comment_text) return await this.service.alert.error("내용을 입력해주세요.");
        let commentFiles = JSON.stringify(this.commentFiles);
        const { code, data } = await wiz.call("comment", { ticket_id: this.ticket_id, text: this.comment_text, files: commentFiles });
        if (code != 200) return await this.service.alert.error("Error!");
        this.comment_text = "";
        this.commentFiles = [];
        await this.service.render();
        await this.load();
        this.editor.data.set(this.comment_text);
    }

    public async removeComment(comment) {
        let res = await this.service.alert.error("댓글을 삭제하시겠습니까?", "닫기", "삭제");
        if (!res) return;
        const { code } = await wiz.call("remove_comment", comment);
        if (code != 200) return await this.service.alert.error("Error!");
        await this.load();
    }

    public async uploadCommentFile() {
        let files = await this.service.file.select();
        if (files.length == 0) return;

        await this.service.loading.show();

        if (!this.commentFiles) this.commentFiles = [];

        for (let i = 0; i < files.length; i++) {
            let fd = new FormData();
            fd.append('upload', files[i]);
            let fdurl = '/file/upload';
            const { url } = await this.service.file.upload(fdurl, fd, async (percent: number, total: number, position: number) => { });
            this.commentFiles.push({ name: files[i].name, url: url });
        }

        await this.service.loading.hide();
        this.service.render();
    }

    public async removeCommentFile(file) {
        this.commentFiles.remove(file);
        this.service.render();
    }

    public async buildEditor() {
        let editor = this.editor = await ClassicEditor.create(this.editorElement.nativeElement, {
            toolbar: {
                items: [
                    'undo', 'redo',
                    '|', 'heading',
                    '|', 'alignment:left', 'alignment:center', 'alignment:right', 'alignment:justify',
                    '|', 'bold', 'italic', 'strikethrough', 'underline',
                    '|', 'bulletedList', 'numberedList', 'outdent', 'indent',
                    '|', 'link', 'uploadImage', 'insertTable', 'blockQuote', 'codeBlock', 'horizontalLine'
                ],
                shouldNotGroupWhenFull: true
            },
            link: {
                addTargetToExternalLinks: true,
                defaultProtocol: 'https://',
            },
            removePlugins: ["MediaEmbedToolbar", "Markdown"],
            table: ClassicEditor.defaultConfig.table,
            simpleUpload: {
                uploadUrl: '/file/upload'
            }
        });

        this.editor.data.set(this.comment_text);
    }

    public statusLabels: { [key: string]: string } = {
        'pending': '접수대기',
        'received': '접수완료',
        'processing': '처리중',
        'completed': '처리완료'
    };

    public getStatusLabel(status: string): string {
        return this.statusLabels[status] || status; // 변환된 값이 없으면 원래 값을 반환
    }

    public getStatusColor(status: string) {
        switch (status) {
            case 'pending': return 'bg-gray-400 text-white';
            case 'received': return 'bg-gray-100 text-green-800';
            case 'process': return 'bg-emerald-100 text-yellow-800';
            case 'finish': return 'bg-indigo-100 text-gray-800';
            default: return 'bg-gray-100 text-gray-800';
        }
    }

    public formatFileSize(bytes: number) {
        if (!Number.isFinite(bytes)) return '-';
        const units = ['B', 'KB', 'MB', 'GB'];
        let i = 0, size = bytes;
        while (size >= 1024 && i < units.length - 1) { size /= 1024; i++; }
        return `${Math.round(size * 100) / 100} ${units[i]}`;
    }

    public getFileIcon(filename: string) {
        const ext = this.getExt(filename);
        switch (ext) {
            case 'pdf': return '📕';
            case 'doc':
            case 'docx': return '📝';
            case 'xls':
            case 'xlsx': return '📊';
            case 'ppt':
            case 'pptx': return '📈';
            case 'txt': return '📄';
            case 'png':
            case 'jpg':
            case 'jpeg':
            case 'gif':
            case 'webp': return '🖼️';
            default: return '📦';
        }
    }

    private getExt(name: string): string | null {
        const i = name.lastIndexOf('.');
        return i >= 0 ? name.slice(i + 1).toLowerCase() : null;
    }
}

export default PortalGsdcuserTicketingItemComponent;